import { motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';

export function PageAnimator() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      className="absolute inset-0"
    >
      <Outlet />
    </motion.div>
  );
}
